import EnterDataFormInputComponent from './enter-data-form-input-component';

/***
 * A row in a enter-data-form that renders a label with either a form to edit the value or a
 * static representation of the currently saved value.
 */
const enterDataFormInput = angular
    .module('FacilityData.EnterData.EnterDataFormInput', [])
    .component('enterDataFormInput', EnterDataFormInputComponent)
    .name;

export default enterDataFormInput;


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form-input/enter-data-form-input.js